import Modal from "react-bootstrap/Modal";
import logoPNG from "../../assets/images/logo.png";
import style from "./modal.module.css";
function Confirm(props) {
  const { messageModal, show, setShow, processData, textConfirm = "SIM", textCancel = "NÃO" } = props;
  const handleClose = () => {
    setShow(false);
  };
  function confirmAction() {
    handleClose();
    processData();
  }
  function cancelAction() {
    handleClose();
  }
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        contentClassName={`rounded-4 overflow-hidden border border-0 bg-brand ${style.modal_loading}`}
        backdropClassName={style.modal_backdrop}
      >
        <Modal.Body className="text-light">
          <div className="d-flex flex-column align-items-center text-center py-3 px-5">
            <img
              src={logoPNG}
              alt="Apito"
              className={style.modal_size_image_logo_loading}
            />
            
            <div className="text-light fs-4 fw-bold">{messageModal}</div>

            <div className={`${style.modal_container_btns_confirm} w-100 mt-3`}>

                <button className={`btn btn-danger fw-bold  ${style.modal_btn_danger}`} onClick={cancelAction}>
                  {textCancel}
                </button>

                <button className={`btn btn-success fw-bold btn ${style.modal_btn_update_success}`} onClick={confirmAction}>
                  {textConfirm}
                </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
var Confirm_default = Confirm;
export {
  Confirm_default as default
};